import { useEffect, useState } from 'react';
import useWSTurnState, { TURN_PHASES } from '../../hooks/useWSTurnState';
import { getDebugVisibility, setDebugVisibility, subscribeDebugVisibility } from '../../utils/debugToggleState';
import TranscriptionDebug from '../StateDebugPanel/TranscriptionDebug';
// eslint-disable-next-line import/no-unresolved, import/extensions
import DeepgramDebugPanel from '../StateDebugPanel/DeepgramDebugPanel';
import './StateDisplay.css';

export default function StateDisplay({ onPhaseChange, onToggleGrid, showDebugGrid }) {
  const { currentPhase } = useWSTurnState();
  const [isVisible, setIsVisible] = useState(getDebugVisibility());

  useEffect(() => {
    const unsubscribe = subscribeDebugVisibility(setIsVisible);

    const handleKeyPress = (event) => {
      if (event.ctrlKey && (event.key === "'" || event.code === 'Backquote')) {
        const { target } = event;
        const isInput = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;

        if (!isInput) {
          event.preventDefault();
          setDebugVisibility(!getDebugVisibility());
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress, true);

    return () => {
      unsubscribe();
      window.removeEventListener('keydown', handleKeyPress, true);
    };
  }, []);

  return (
    <div style={{ display: isVisible ? 'block' : 'none' }} className="state-display">
      {/* Header */}
      <div className="debug-header">
        <span className="debug-title">📊 State Display</span>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <button
            type="button"
            onClick={onToggleGrid}
            className="grid-toggle-btn"
            style={{
              background: showDebugGrid ? '#dc3545' : '#28a745',
              color: 'white',
              border: 'none',
              padding: '4px 8px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '10px'
            }}
          >
            {showDebugGrid ? 'Hide Grid' : 'Show Grid'}
          </button>
        </div>
      </div>

      {/* Ações de Fase */}
      <div className="debug-actions">
        <div className="actions-group">
          <span className="actions-label">Slide Phases:</span>
          <div className="actions-buttons">
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.WaitingPartner)}
              className={`action-btn ${currentPhase === TURN_PHASES.WaitingPartner ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Waiting
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.Welcome)}
              className={`action-btn ${currentPhase === TURN_PHASES.Welcome ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Welcome
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.GroundRules)}
              className={`action-btn ${currentPhase === TURN_PHASES.GroundRules ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Rules
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.SelfIntroductions)}
              className={`action-btn ${currentPhase === TURN_PHASES.SelfIntroductions ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Intro
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.SelfIntroductionsA)}
              className={`action-btn ${currentPhase === TURN_PHASES.SelfIntroductionsA ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Intro A
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.SelfIntroductionsAtoB)}
              className={`action-btn ${currentPhase === TURN_PHASES.SelfIntroductionsAtoB ? 'action-btn-active' : 'action-btn-default'}`}
            >
              A→B
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.SelfIntroductionsB)}
              className={`action-btn ${currentPhase === TURN_PHASES.SelfIntroductionsB ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Intro B
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.SelfIntroductionsDone)}
              className={`action-btn ${currentPhase === TURN_PHASES.SelfIntroductionsDone ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Intro Done
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.TodayTheme)}
              className={`action-btn ${currentPhase === TURN_PHASES.TodayTheme ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Today Theme
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.FreeChat)}
              className={`action-btn ${currentPhase === TURN_PHASES.FreeChat ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Free Chat
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.ACompleting)}
              className={`action-btn ${currentPhase === TURN_PHASES.ACompleting ? 'action-btn-active' : 'action-btn-default'}`}
            >
              A Completing
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.BCompleting)}
              className={`action-btn ${currentPhase === TURN_PHASES.BCompleting ? 'action-btn-active' : 'action-btn-default'}`}
            >
              B Completing
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.AQuestion)}
              className={`action-btn ${currentPhase === TURN_PHASES.AQuestion ? 'action-btn-active' : 'action-btn-default'}`}
            >
              A Question
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.BQuestion)}
              className={`action-btn ${currentPhase === TURN_PHASES.BQuestion ? 'action-btn-active' : 'action-btn-default'}`}
            >
              B Question
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.Goodbye)}
              className={`action-btn ${currentPhase === TURN_PHASES.Goodbye ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Goodbye
            </button>
            <button
              type="button"
              onClick={() => onPhaseChange(TURN_PHASES.Checkout)}
              className={`action-btn ${currentPhase === TURN_PHASES.Checkout ? 'action-btn-active' : 'action-btn-default'}`}
            >
              Checkout
            </button>
          </div>
        </div>
      </div>

      {/* Transcription Debug */}
      <TranscriptionDebug />
      <DeepgramDebugPanel />
    </div>
  );
}
